const DATA_TEST_IDS = {
  notGeoValidatedAddressView:
    'profile-address__fragments_not-geo-validated-address-view',
} as const;

export default DATA_TEST_IDS;
